import {
  Box,
  Typography,
  Grid,
  makeStyles,
  CardMedia,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import HelpIcon from "@material-ui/icons/Help";
import CreateIcon from "@material-ui/icons/Create";

import SfBreadcrumb from "../../../components/SfBreadcrumbs";
import MemberIcon from "../../../assets/member.png";
import BigTab from "../../../components/BigTab";
import { useTranslate } from "react-admin";
import { useEffect, useState } from "react";
import useCheckPermission from "../../../hooks/useCheckPermission";
import { isLiteVersion } from "../../../utils/settings";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    top: 0,
    borderRadius: 0,
  },
  tabContainer: {
    paddingTop: 20,
    padding: 20,
    width: "100%",
    margin: "0 auto",
  },
  memberTab: {
    width: 278,
    height: 366,
    alignSelf: "center",
  },
  walkInTab: {
    width: 278,
    height: 278,
  },
  registerTab: {
    marginTop: 15,
    width: 278,
    height: 73,
  },
  bigIconwithTextContainer: {
    display: "grid",
    gridTemplateRows: "134px 55px",
    justifyContent: "center",
    alignItems: "center",
  },
  bigIconwithTextContainer_text: {
    fontSize: 28,
    fontWeight: 500,
    paddingTop: 10,
    color: theme.typography.button.color,
  },
  bigIconwithTextContainer_icon: { width: 112, height: 112 },
  helpIcon: { width: 134.5, height: 134.5 },
  smallIconwithTextContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  smallIconwithTextContainer_text: {
    fontSize: 24,
    color: theme.typography.button.color,
    fontWeight: 500,
    paddingLeft: 10,
  },
  smallIconwithTextContainer_icon: { width: 31, height: 35 },
}));

const PaymentSelectCustomerType = () => {
  const classes = useStyles();
  const history = useHistory();
  const translate = useTranslate();
  const { checkWritePermission } = useCheckPermission();
  const [allowTomakePayment, setAllowTomakePayment] = useState(false);

  async function checkData() {
    const allowTomakePayment = await checkWritePermission(
      "Page.Merchant.Payment"
    );
    setAllowTomakePayment(allowTomakePayment);
  }
  useEffect(() => {
    checkData();
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid className={classes.allContainer} container>
      <Grid item xs={12}>
        <SfBreadcrumb path="/Payment" />
        <Typography style={{ fontSize: 20, margin: 70 }} align="center">
          {translate("ra.text.payment.selectMemberType")}
        </Typography>
      </Grid>
      <Grid item xs={12} container>
        <Grid
          item
          xs={6}
          style={{
            textAlign: "right",
            paddingRight: 30,
          }}
        >
          <BigTab
            selected
            onClick={() => {
              history.push("/payment/search-member");
            }}
            label="MEMBER"
            className={classes.memberTab}
          >
            <Box className={classes.bigIconwithTextContainer}>
              <CardMedia
                image={MemberIcon}
                className={classes.bigIconwithTextContainer_icon}
              />

              <Typography className={classes.bigIconwithTextContainer_text}>
                {translate("ra.text.payment.member")}
              </Typography>
            </Box>
          </BigTab>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            textAlign: "left",
            paddingLeft: 30,
          }}
        >
          <BigTab
            selected
            disabled={!allowTomakePayment}
            onClick={() => {
              history.push({
                pathname: isLiteVersion()
                  ? "/payment/lite"
                  : "/payment/addproduct",
                state: { memberInfo: null },
              });
            }}
            className={classes.walkInTab}
          >
            <Box className={classes.bigIconwithTextContainer}>
              <HelpIcon classes={{ root: classes.helpIcon }} />
              <Typography className={classes.bigIconwithTextContainer_text}>
                {translate("ra.text.payment.walkIn")}
              </Typography>
            </Box>
          </BigTab>
          <BigTab
            selected
            onClick={() => {
              history.push({
                pathname: "/customers/register",
              });
            }}
            label="Register"
            className={classes.registerTab}
          >
            <Box className={classes.smallIconwithTextContainer}>
              <CreateIcon className={classes.smallIconwithTextContainer_icon} />
              <Typography className={classes.smallIconwithTextContainer_text}>
                {translate("ra.text.payment.register")}
              </Typography>
            </Box>
          </BigTab>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PaymentSelectCustomerType;
